import { captureSubmitError } from './captureSubmitError'
import { captureSubmitPerformance } from './captureSubmitPerformance'
import { forwardTo } from '../default/forwardTo'
import { updateSession } from '../default/updateSession'
import { verifyPhoneVeracity } from '../middleware/verifyPhoneVeracity'

/**
 * Submits phone number for sms code verification
 * @param {string} phone
 * @param {string} sessionId
 * @param {string} redirect
 * @returns {Promise<boolean>}
 */
export async function submitPhoneVeracity(phone, sessionId, redirect) {
  const startTime = performance.now()
  try {
    const success = await verifyPhoneVeracity(phone)
    if (success) {
      updateSession(sessionId, 'phone', phone)

      if (window.location.pathname !== redirect) {
        forwardTo(redirect)
      }

      captureSubmitPerformance(performance.now() - startTime)
      return true
    }
  } catch (error) {
    captureSubmitPerformance(performance.now() - startTime)
    captureSubmitError(/** @type {Error} */ (error), false)
  }
  return false
}
